import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import globals from './globals'
import Popper from 'popper.js'
import {ServerTable, ClientTable, Event} from 'vue-tables-2';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import VueToastr from 'vue-toastr';
import vue2Dropzone from 'vue2-dropzone';
import vSelect from 'vue-select'
import vueHeadful from 'vue-headful';
import api from './helpers/Api';
import store from './store';
import DOMPurify from 'dompurify';

//Set Global Tools
Vue.prototype.$http = api;
Vue.prototype.$sanitize = (dirty) => DOMPurify.sanitize(dirty);
Vue.prototype.$safeUrl = (url) => /^https?:\/\//i.test(url) ? url : '#';
moment.tz.setDefault("UTC"); //This needs to be set to the database storage timestamp

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false

Vue.config.productionTip = false

//Componenets
Vue.component('address-editor', require('./components/layouts/AddressEditor.vue').default);
Vue.component('address-list', require('./components/layouts/AddressList.vue').default);
Vue.component('agency-typeahead', require('./components/agencies/Typeahead.vue').default);
Vue.component('audit-entry-list', require('./components/inspections/AuditEntryList.vue').default);
Vue.component('comments-list', require('./components/comments/List.vue').default);
Vue.component('comments-form', require('./components/comments/Form.vue').default);
Vue.component('contact-list', require('./components/layouts/ContactList.vue').default);
Vue.component('date-filter', require('./components/layouts/DateFilter.vue').default);
Vue.component('downline-list', require('./components/layouts/DownlineList.vue').default);
Vue.component('agent-typeahead', require('./components/agents/Typeahead.vue').default);
Vue.component('defects-list', require('./components/defects/List.vue').default);
Vue.component('email-editor', require('./components/layouts/EmailEditor.vue').default);
Vue.component('email-list', require('./components/layouts/EmailList.vue').default);
Vue.component('files-list', require('./components/files/List.vue').default);
Vue.component('files-list-table', require('./components/files/ListTable.vue').default);
Vue.component('files-create-edit-modal', require('./components/files/CreateOrEditViaModal.vue').default);
Vue.component('file-uploader', require('./components/files/FileUploader.vue').default);
Vue.component('files-add', require('./components/files/Add.vue').default);
Vue.component('floating-date-picker', require('./components/ui/FloatingDatePicker.vue').default);
Vue.component('hierarchy-table-row', require('./components/reports/HierarchyTableRow.vue').default);
Vue.component('history-list', require('./components/history/List.vue').default);
Vue.component('inspections-list', require('./components/inspections/List.vue').default);
Vue.component('inspections-typeahead', require('./components/inspections/Typeahead.vue').default);
Vue.component('login-list', require('./components/users/LoginList.vue').default);
Vue.component('parts-list', require('./components/parts/List.vue').default);
Vue.component('part-typeahead', require('./components/parts/Typeahead.vue').default);
Vue.component('phone-editor', require('./components/layouts/PhoneEditor.vue').default);
Vue.component('phone-list', require('./components/layouts/PhoneList.vue').default);
Vue.component('products-assigned', require('./components/products/Assigned.vue').default);
Vue.component('products-managed', require('./components/products/Managed.vue').default);
Vue.component('payroll-list', require('./components/payroll/List.vue').default);
Vue.component('saved-reports-list', require('./components/reports/List.vue').default);
Vue.component('schedule-name', require('./components/reports/ScheduleName.vue').default);
Vue.component('v-select', vSelect);
Vue.component('vue2-dropzone', vue2Dropzone);
Vue.component('vue-headful', vueHeadful);

//USING
Vue.use(BootstrapVue);
Vue.use(VueMoment, {moment});
Vue.use(VueToastr);

//USING with config
Vue.use(ServerTable, {
    //columnsDropdown: true,
    debounce: 1000,
    requestFunction: function (data) {
        //Use the API class
        return this.$http.get(this.url, data)
        .catch(function (e) {
            this.dispatch('error', e);
        }.bind(this));
    },
    footerHeadings: true,
    skin: 'table table-striped table-bordered table-sm table-hover',
    perPage: 50,
    perPageValues: [10, 25, 50, 100],
    sortIcon:{
        is:'fa-sort',
        base:'fa',
        up: 'fa-sort-up',
        down: 'fa-sort-down'
    },
    texts:{
        count:"{from} to {to} of {count} Records|{count} records|One Record",
        first:'First',
        last:'Last',
        filter:"",
        filterPlaceholder:"Search Records",
        limit:"",
        page:"Page:",
        noResults:"No Records Found",
        filterBy:"Filter by {column}",
        loading:'Loading...',
        defaultOption:'Select {column}',
        columns:'Columns'
    },
}, false, 'bootstrap4', 'default');

Vue.use(ClientTable, {
    //columnsDropdown: true,
    debounce: 1000,
    // requestFunction: function (data) {
    //     //Use the API class
    //     return this.$http.get(this.url, data)
    //     .catch(function (e) {
    //         this.dispatch('error', e);
    //     }.bind(this));
    // },
    footerHeadings: true,
    skin: 'table table-striped table-bordered table-sm table-hover',
    perPage: 50,
    perPageValues: [10, 25, 50, 100],
    sortIcon:{
        is:'fa-sort',
        base:'fa',
        up: 'fa-sort-amount-asc',
        down: 'fa-sort-amount-desc'
    },
    texts:{
        count:"{from} to {to} of {count} Records|{count} records|One Record",
        first:'First',
        last:'Last',
        filter:"",
        filterPlaceholder:"Search Records",
        limit:"",
        page:"Page:",
        noResults:"No Records Found",
        filterBy:"Filter by {column}",
        loading:'Loading...',
        defaultOption:'Select {column}',
        columns:'Columns'
    },
}, false, 'bootstrap4', 'default');

Vue.filter('humanReadableTime', function(valueInSeconds){
  //Make sure the value isn't null or empty
  if(!valueInSeconds || valueInSeconds == '')
  {
      return valueInSeconds;
  }

  //Setup
  var humanTime = '';
  var secondsInAnHour = 3600;

  //Get minutes
  var minutes = valueInSeconds / 60;

  //Check if LESS than 1 hour?

  //Send it
  return (valueInSeconds / 3600).toFixed(2) + 'h';
});

Vue.filter('ssn', function(rawSsn){
  //Make sure the value isn't null or empty
  if(!rawSsn || rawSsn == '')
  {
    return rawSsn;
  }

  //Check if the String Length != 9
  if(rawSsn.length !== 9)
  {
    return rawSsn;
  }

  //Send it
  return (rawSsn.substring(0,3) + '-' + rawSsn.substring(3,5) + '-' + rawSsn.substring(5,9));
});

Vue.filter('taxId', function(rawTaxId){
  //Make sure the value isn't null or empty
  if(!rawTaxId || rawTaxId == '')
  {
    return rawTaxId;
  }

  //Check if the String Length != 9
  if(rawTaxId.length !== 9)
  {
    return rawTaxId;
  }

  //Send it
  return (rawTaxId.substring(0,2) + '-' + rawTaxId.substring(2,9));
});

Vue.filter('phone', function(rawPhone){
  //Make sure the value isn't null or empty
  if(!rawPhone || rawPhone == '')
  {
    return rawPhone;
  }

  //Check if the String Length != 9
  if(rawPhone.length !== 10)
  {
    return rawPhone;
  }

  //Send it
  return (rawPhone.substring(0,3) + '-' + rawPhone.substring(3,6) + '-' + rawPhone.substring(6,10));
});

// Global RTL flag
Vue.mixin({
  data: globals
});

new Vue({
  router,
  store: store,
  data() {
      return {
          debug: process.env.MIX_BASE_DEBUG,
          appUrl: process.env.MIX_APP_URL,
          sandbox_sync: process.env.MIX_APP_SANDBOX_SYNC,
          timezone: 'America/New_York',
      }
  },

  methods: {

    //Permission Check
    hasPermission: function(slug){
        //Make sure the state user is loading
        if(this.$store.state.user == null)
        {
            return false;
        }

        //If slug is a string, make it an array
        if(typeof slug == "string")
        {
            slug = [slug];
        }

        //Check permissiosn are present
        if(!this.$store.state.user.permissions)
        {
          return false;
        }

        //If any of the slugs exist
        var matches = slug.filter(value => -1 !== this.$store.state.user.permissions.indexOf(value));

        //Return it
        return (matches.length > 0);
    },

    isImage(ext){
      var imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'jfif'];

      if(imageExts.indexOf(ext.toLowerCase()) === -1)
      {
        return false;
      }

      return true;
    },

    loadUsers(){
      //Set it
      this.$http.get('/users', {for_filters: true})
        .then(response => {
          //Set the users
          this.$store.commit('users', response.data.data);
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {

        });
    },

    convertHumanReadableToInt(humanReadableValue){
        //Make sure it's valid
        if(humanReadableValue.indexOf('h') === -1 && humanReadableValue.indexOf('m') === -1)
        {
            throw 'Invalid Time Input';
        }

        //Parse the value
        var seconds = 0;
        var parts = humanReadableValue.toLowerCase().split(' ');

        for(var i = 0; i < parts.length; i++)
        {
            //Set the value
            var stringValue = parts[i];

            //Check for hours
            if(stringValue.indexOf('h') !== -1)
            {
                //Increment
                seconds += (parseFloat(parts[i].replace('h', '')) * 3600);
            }

            //Check for minutes
            if(stringValue.indexOf('m') !== -1)
            {
                //Increment
                seconds += (parseFloat(parts[i].replace('m', '')) * 60);
            }
        }

        //Send it
        return seconds;
    },

    convertToHumanReadable(timeInSeconds){
        //Setup
        var hours = timeInSeconds / 3600;
        var minutesInSeconds = timeInSeconds % 3600;
        var returnTime = '';

        //If greater than 1, append
        if(hours >= 1)
        {
            returnTime += Math.floor(hours) + 'h ';
        }

        //Add minutes
        if(minutesInSeconds > 0)
        {
            returnTime += parseFloat((minutesInSeconds / 60).toFixed(2)) + 'm';
        }

        //Send it
        return returnTime.trim();
    },

    arrayIncludes(array, needle) {
      // If it isn't an array, it doesn't contain the needle
      if (!Array.isArray(array))
      {
        return false;
      }

      // Loop through, if the array has the needle, return true
      for (let i = 0; i < array.length; i++)
      {
        if (array[i] == needle)
        {
          return true;
        }
      }

      // Didn't find it
      return false;
    },

    getUserIdentity(){
      //Check for a missing token
      // if(!localStorage.getItem('amos_365_token', null))
      // {
      //   //Send to login
      //   window.location = '/login';
      // }

      //Set it
      this.$http.get('/users/identity')
        .then(response => {
          //Set the users
          this.$store.commit('login', response.data);
        })
        .catch(error => {
          console.log(error);

          //IF the token is BAD, remove it and send to login
          if(false)
          {
            //Bad Token
            //localStorage.removeItem('amos_365_token');

            //Send to login
            //window.location = '/login';
          }
        })
        .then(() => {

        });
    },

    getRecordPlural(record_type){
      //Setup
      var plural = record_type.toLowerCase() + 's';

      //Special Cases
      switch(record_type)
      {
          case 'Agency':
              //Set
              plural = 'agencies';
              break;

          case 'ProductContract':
              //Set
              plural = 'contracts';
              break;

          case 'Policy':
            //Set
            plural = 'policies';
            break;
      }

      return plural;
    },

    getUrl(item){
        //Get it
        var url = this.getRecordPlural(item.record_type);

        //Send URL
        return '/' + url + '/view/'+item.record_id;
    },

    getRecordName(item){
        //Check for record
        if(!item.record)
        {
            return 'View ' + item.record_type;
        }

        //Setup
        var name = item.record[item.record_type.toLowerCase() + '_name'];

        //Special Cases
        switch(item.record_type)
        {
            case 'Agent':
                //Set
                name = item.record.first_name + ' ' + item.record.last_name;
                break;
            case 'ProductContract':
                //Set
                name = 'Product: '+item.record.product_name+', Seller: '+item.record.seller_id+', Writing#: '+(item.record.writing_nbr != null ? item.record.writing_nbr : '');
                break;
        }

        //Send URL
        return name;
    },

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
  },

  created(){
      //Load the list of users. this is used everywhere for filtering, selecting, etc.
      //this.loadUsers();

      //Set user from window variable
      //this.$store.commit('login', window.appUser);

      //Attempt to Get the user from the identity
      this.getUserIdentity();

      //Setup Contants
      this.$store.commit('constants', window.constants);

      //Set the token passed in on the blade
      //localStorage.setItem('app_token', window['appToken']);

      //Set the falg
      this.$store.commit('appLoading');

      //Setup
      this.$toastr.defaultPosition = "toast-bottom-right";
  },

  mounted(){
  	//Check login
  	if(!this.$store.state.user)
  	{

  	}
  },

  render: h => h(App)
}).$mount('#app')
